import { render, staticRenderFns } from "./LinkFiles.vue?vue&type=template&id=1621574a&"
import script from "./LinkFiles.vue?vue&type=script&lang=js&"
export * from "./LinkFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports